import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAuthStore = create(
  persist(
    (set) => ({
      // --------------------
      // AUTH STATE
      // --------------------
      user: null,
      accessToken: null,
      token: null,
      role: null,
      isAuthenticated: false,
      isGlobalOnboardingRequired: true,

      // 🔑 IMPORTANT: hydration flag
      isAuthHydrated: false,

      // --------------------
      // ACTIONS
      // --------------------
      /**
       * @param {any} userData
       * @param {string} token
       * @param {boolean} [isGlobalOnboardingRequired]
       */
      login: (userData, token, isGlobalOnboardingRequired = true) => {
        // Legacy localStorage support (kept intentionally)
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", token);
        localStorage.setItem("role", userData.role);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userName", userData.name);
        localStorage.setItem("userEmail", userData.email);
        localStorage.setItem("userPhone", userData.phone);
        localStorage.setItem("isGlobalOnboardingRequired", String(isGlobalOnboardingRequired));

        set({
          user: userData,
          accessToken: token,
          token,
          role: userData.role,
          isAuthenticated: true,
          isGlobalOnboardingRequired,
        });
      },

      /** @param {string|null} nextToken */
      setAccessToken: (nextToken) => {
        if (nextToken) {
          localStorage.setItem("token", nextToken);
        } else {
          localStorage.removeItem("token");
        }

        set({
          accessToken: nextToken,
          token: nextToken,
          isAuthenticated: Boolean(nextToken),
        });
      },

      logout: () => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userPhone");
        localStorage.removeItem("isGlobalOnboardingRequired");

        set({
          user: null,
          accessToken: null,
          token: null,
          role: null,
          isAuthenticated: false,
          isGlobalOnboardingRequired: true,
        });
      },
    }),
    {
      name: "auth-storage",

      // Persist only required fields
      partialize: (state) => ({
        user: state.user,
        role: state.role,
        isAuthenticated: state.isAuthenticated,
        isGlobalOnboardingRequired: state.isGlobalOnboardingRequired,
      }),

      // 🔑 CALLED AFTER REHYDRATION
      onRehydrateStorage: () => (state) => {
        state?.setState({ isAuthHydrated: true });
      },
    }
  )
);

export default useAuthStore;